import { Router, Routes } from "@/lib/router";
import { Navbar } from "@/components/Navbar";
import { BountyList } from "@/pages/BountyList";
import { BountyDetail } from "@/pages/BountyDetail";
import { CreateBounty } from "@/pages/CreateBounty";
import { Leaderboard } from "@/pages/Leaderboard";
import { Profile } from "@/pages/Profile";
import "./index.css";

const routes = [
	{ path: "/", component: BountyList },
	{ path: "/bounty/new", component: CreateBounty },
	{ path: "/bounty/:id", component: BountyDetail },
	{ path: "/leaderboard", component: Leaderboard },
	{ path: "/profile/:id", component: Profile },
];

export function App() {
	return (
		<Router>
			<div className="min-h-screen bg-background">
				<Navbar />
				<Routes routes={routes} />
			</div>
		</Router>
	);
}

export default App;
